import PasswordField from './PasswordField.component';

export default PasswordField;